import firebase from '../../../config/firebase';

const database = firebase.database();

/**
 * get all franchise locations
 */
export function getLocations(callback) {

  database.ref('locations').on('value', function(snapshot) {
      const locations = snapshot.val();
      if (locations) {
        callback(true, locations, null);
      }
      else {
        callback(true, null, null);
      }
    });
}

/**
 * Create new location
 */
export function createNewLocation (data, callback) {
  var newId = database.ref().child('locations').push().key;
  data["id"] = newId;

  database.ref('locations/' + newId).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

/**
 * Edit location
 */
export function editLocation (id, data, callback) {

  database.ref('locations/' + id).update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

export function archiveLocationOffer(id, data, callback) {
  database.ref('locations')
    .child(id)
    .child('offersArchive')
    .child(data.offerId)
    .set(data, function(error) {
       callback(error);
    })
}

/**
 * Delete location
 */
export function deleteLocation(id, callback) {
  database.ref('locations').child(id).remove(function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, id, null);
    }
  });
}
